import { Component, Input, Output, EventEmitter, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { UserEvent, EventType } from '../../services/events.service';
import { SvgWrapperComponent, isEventStarted, isEventCompleted, isEventActive, formatDate, getLocaleFromLang } from 'quest-atlas-angular-components';

@Component({
  selector: 'app-event-card',
  imports: [CommonModule, TranslocoModule, SvgWrapperComponent],
  templateUrl: './event-card.component.html',
  styleUrl: './event-card.component.scss'
})
export class EventCardComponent {
  event = input.required<UserEvent>();
  showActions = input<boolean>(false);

  // Computed state using shared event status functions
  isEventStarted = computed(() => isEventStarted(this.event()));
  isEventCompleted = computed(() => isEventCompleted(this.event()));
  isEventActive = computed(() => isEventActive(this.event()));

  // Get current locale for date formatting
  currentLocale = computed(() => getLocaleFromLang(this.transloco.getActiveLang()));

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  EventType = EventType;

  constructor(private transloco: TranslocoService) {}

  getContentDescription(): string {

    if (this.event().quests && this.event().quests.length > 0) {
      return this.event().quests.length === 1 ? 'quest' : 'quests';
    }

    if (this.event().obelisks && this.event().obelisks.length > 0) {
      return this.event().obelisks.length === 1 ? 'place' : 'places';
    }

    if (this.event().compilations && this.event().compilations.length > 0) {
      return this.event().compilations.length === 1 ? 'trip' : 'trips';
    }

    return 'noContentSelectedYet';
  }

  getStatusClass(): string {
    if (this.isEventCompleted()) return 'status-completed';
    if (this.isEventActive()) return 'status-active';
    return 'status-upcoming';
  }

  getStatusText(): string {
    if (this.isEventCompleted()) return 'finished';
    if (this.isEventActive()) return 'activeSingle';
    return 'upcomingEvent';
  }

  /**
   * Formats a date using the current locale
   */
  formatEventDate(date: Date | undefined): string {
    return formatDate(date, this.currentLocale());
  }

  onEdit(event: Event): void {
    event.stopPropagation();
    this.edit.emit();
  }

  onDelete(event: Event): void {
    event.stopPropagation();
    this.delete.emit();
  }
}


